// Resolves the API base URL.
// In production, REACT_APP_BACKEND_URL may be set to the apex domain
// (e.g. https://bodamarcelyaida.com) while the visitor is on www.bodamarcelyaida.com
// (or vice versa). Cross-host redirects break the CORS preflight, so when the
// backend host matches the current host (ignoring the `www.` prefix), we use the
// current window origin to keep the request same-origin.

const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

const normalize = (host) => host.replace(/^www\./i, "").toLowerCase();

const computeBase = () => {
  if (!ENV_URL) return "";
  if (typeof window === "undefined") return ENV_URL;
  try {
    const envHost = normalize(new URL(ENV_URL).hostname);
    const winHost = normalize(window.location.hostname);
    if (envHost && envHost === winHost) {
      return window.location.origin;
    }
  } catch (_) {
    /* fall through */
  }
  return ENV_URL;
};

export const API_BASE = computeBase();
export const API = `${API_BASE}/api`;
